<template>
  <v-container fluid>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="mb-3">
      <el-breadcrumb-item :to="{ path: '/' }">แดชบอร์ด</el-breadcrumb-item>
      <el-breadcrumb-item>ออเดอร์วันนี้</el-breadcrumb-item>
    </el-breadcrumb>

    <v-layout row wrap class="my-5 mx-0">
      <v-flex xs12 sm12 md12>
        <el-card class="box-card">
          <v-layout wrap>
            <v-flex class="align-center text-center">
              <v-skeleton-loader :loading="isLoading" type="list-item-two-line">
                <strong>ยอดขาย</strong>
                <br />
                <h4 class="mt-2">
                  ฿ {{ amount.revenue | numFormat("0,0.00") }}
                </h4>
              </v-skeleton-loader>
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-center">
              <v-skeleton-loader :loading="isLoading" type="list-item-two-line">
                <strong>ค่าสินค้า</strong>
                <br />
                <h4 class="mt-2">
                  ฿
                  {{
                    (parseFloat(amount.food) + parseFloat(amount.vat))
                      | numFormat("0,0.00")
                  }}
                </h4>
              </v-skeleton-loader>
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-center">
              <v-skeleton-loader :loading="isLoading" type="list-item-two-line">
                <strong>ค่าจัดส่ง</strong>
                <br />
                <h4 class="mt-2">
                  ฿ {{ amount.delivery | numFormat("0,0.00") }}
                </h4>
              </v-skeleton-loader>
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-center">
              <v-skeleton-loader :loading="isLoading" type="list-item-two-line">
                <strong>ส่วนลด</strong>
                <br />
                <h4 class="mt-2">
                  ฿ {{ amount.discount | numFormat("0,0.00") }}
                </h4>
              </v-skeleton-loader>
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-center">
              <v-skeleton-loader :loading="isLoading" type="list-item-two-line">
                <strong>จำนวนบิล</strong>
                <br />
                <h4 class="mt-2">
                  {{
                    ((amount.completed / orderList.length) * 100)
                      | numFormat("0,0")
                  }}%
                  <span>({{ amount.completed }}/{{ orderList.length }})</span>
                </h4>
              </v-skeleton-loader>
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-center">
              <v-skeleton-loader :loading="isLoading" type="list-item-two-line">
                <strong>จำนวนสินค้า</strong>
                <br />
                <h4 class="mt-2">
                  {{ amount.quantity | numFormat("0,0") }}
                </h4>
              </v-skeleton-loader>
            </v-flex>
          </v-layout>
        </el-card>
      </v-flex>
    </v-layout>

    <el-card class="mt-3">
      <v-data-table
        :headers="headers"
        :items="orderList"
        :loading="isLoading"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        :mobile-breakpoint="`10`"
        @page-count="pageCount = $event"
        hide-default-footer
        class="elevation-0"
      >
        <template v-slot:no-data>
          <div class="text-xs-center">
            <img src="../../assets/img/no-order.png" style="width: 30%" />
          </div>
        </template>

        <template v-slot:item.order_type="{ item }">
          <div style="min-height: 60px; width: 140px">
            <div class="pt-3">
              <el-tooltip
                content="เดลิเวอรี่"
                placement="top"
                v-if="
                  item.order_type == 'delivery' ||
                    item.order_type == 'delivery-self'
                "
              >
                <i class="fas fa-motorcycle mr-2"></i>
              </el-tooltip>
              <el-tooltip
                content="คอมเมิร์ซ"
                placement="top"
                v-if="item.order_type == 'commerce'"
              >
                <i class="fas fa-shopping-bag mr-2"></i>
              </el-tooltip>
              <el-tooltip
                content="รับเองที่ร้าน"
                placement="top"
                v-if="item.order_type == 'pickup'"
              >
                <i class="fas fa-store mr-2"></i>
              </el-tooltip>

              <el-tooltip
                content="สั่งจาก POS"
                placement="top"
                v-if="['dinein', 'dinein-buffet'].includes(item.order_type)"
              >
                <i class="fas fa-desktop mr-2"></i>
              </el-tooltip>

              <span class="grey--text">{{ item.order_reference }}-</span>
              {{ item.order_id | numFormat("00000") }}
            </div>

            <div
              v-if="item.status == 'cancelled'"
              class="grey lighten-2 badge-status"
            >
              ยกเลิกแล้ว
            </div>
            <div
              v-if="item.status == 'pending'"
              class="grey darken-2 badge-status"
            >
              <i class="far fa-clock"></i> รอชำระเงิน
            </div>
            <div v-else-if="item.status == 'new'" class="red badge-status">
              มาใหม่
            </div>
            <div
              v-if="item.status == 'accepted' || item.status == 'captured'"
              class="amber darken-1 badge-status"
            >
              ยืนยันแล้ว
            </div>
            <div
              v-if="item.status == 'processing'"
              class="blue darken-2 badge-status"
            >
              ส่งให้ร้านแล้ว
            </div>
            <div
              v-if="item.status == 'cooking'"
              class="blue darken-4 badge-status"
            >
              กำลังดำเนินการ
            </div>
            <div
              v-if="item.status == 'ready-to-go'"
              class="pink lighten-3 badge-status"
            >
              พร้อมจัดส่ง
            </div>
            <div
              v-if="item.status == 'delivering'"
              class="pink lighten-1 badge-status"
            >
              กำลังจัดส่ง
            </div>
            <div
              v-if="item.status == 'completed'"
              class="green lighten-1 badge-status"
            >
              เรียบร้อยแล้ว
            </div>
          </div>
        </template>

        <template v-slot:item.action="{ item }">
          <el-button type="text" size="small" @click="openItem(item)"
            >ดูรายละเอียด</el-button
          >
        </template>

        <template v-slot:item.datetime_received="{ item }">
          <!-- เวลารับอาหาร -->
          <div style="width: 150px">
            <div>{{ item.datetime_received | moment("DD/MM/YY HH:mm") }}</div>
            <div v-if="item.cluster_id != null">
              <el-tag
                v-if="
                  item.shop.cluster_json.find((x) => x.id == item.cluster_id)
                "
                size="mini"
                type="info"
                >รอบส่ง
                {{
                  item.shop.cluster_json.find((x) => x.id == item.cluster_id)
                    .delivery
                }}</el-tag
              >
            </div>
            <div v-if="item.driver_info_json != null">
              <a
                v-if="item.driver_type == 'lalamove'"
                :href="
                  `https://share.lalamove.com/?TH` +
                    item.driver_info_json.orderRef +
                    `&lang=th_TH`
                "
                target="_blank"
              >
                <img
                  src="../../assets/img/icon-lalamove.png"
                  style="width: 20px"
                />
              </a>

              <img
                v-if="item.driver_type == 'grab-instant'"
                src="../../assets/img/icon-grab-instant.png"
                style="width: 20px"
              />
            </div>
          </div>
        </template>

        <template v-slot:item.user_ref_json="{ item }">
          <!-- ข้อมูลลูกค้า -->

          <div v-if="['dinein', 'dinein-buffet'].includes(item.order_type)">
            <strong>{{ item.custom_5 }}</strong>
          </div>
          <div v-else style="width: 120px">
            <template v-if="item.user_ref_json != null">
              <strong class="line-1-elipsis"
                >{{ item.user_ref_json.firstname }}
                {{ item.user_ref_json.lastname }}</strong
              >
              <div>
                <span class="font-xs">
                  <i class="fas fa-mobile-alt"></i>
                  {{ item.user_ref_json.mobile }}
                </span>
              </div>
            </template>
          </div>
        </template>

        <template v-slot:item.delivery_info_json="{ item }">
          <!-- เส้นทาง -->
          <div style="width: 220px; padding: 10px 0">
            <ul
              class="my-progress"
              v-if="
                item.order_type == 'delivery' ||
                  item.order_type == 'delivery-self'
              "
            >
              <li class="progress__item progress__item--completed">
                <p class="progress__title">
                  <img :src="item.shop.logo_url" style="height: 22px" />
                  {{ item.shop.name }}<span> | {{ item.custom_2 }}</span>
                </p>
              </li>
              <li class="progress__item progress__item--active">
                <p class="progress__title">
                  <el-tooltip
                    v-if="item.delivery_info_json.whereTo.address.text"
                    class="item"
                    effect="dark"
                    placement="top-start"
                  >
                    <div slot="content" style="width: 200px">
                      {{ item.delivery_info_json.whereTo.address.text }}
                    </div>
                    <span>{{
                      item.delivery_info_json.whereTo.address.text
                    }}</span>
                  </el-tooltip>
                  <el-tooltip
                    v-else
                    class="item"
                    effect="dark"
                    placement="top-start"
                  >
                    <div slot="content" style="width: 200px">
                      {{ item.delivery_info_json.whereTo.address }}
                    </div>
                    <span>{{ item.delivery_info_json.whereTo.address }}</span>
                  </el-tooltip>

                  <span
                    v-if="item.distance != null && item.distance != -1"
                    class="font-xs black--text text-xs-left"
                    >(ระยะทาง
                    {{ (item.distance / 1000) | numFormat("0.00") }} km)</span
                  >
                </p>
              </li>
            </ul>
            <ul class="my-progress" v-if="item.order_type == 'pickup'">
              <li class="progress__item progress__item--completed">
                <p class="progress__title">
                  <img :src="item.shop.logo_url" style="height: 22px" />
                  รับอาหารที่ร้าน {{ item.shop.name }}
                </p>
              </li>
            </ul>
            <ul
              class="my-progress"
              v-if="['dinein', 'dinein-buffet'].includes(item.order_type)"
            >
              <li class="progress__item progress__item--completed">
                <p class="progress__title">
                  <img :src="item.shop.logo_url" style="height: 22px" />
                  {{ item.shop.name }}
                </p>
              </li>
            </ul>
          </div>
        </template>

        <template v-slot:item.amount="{ item }">
          <div @click="openPaymentInfo(item)">
            <strong>฿ {{ item.amount.total | numFormat("0,0.00") }}</strong>
            <br />

            <span
              class="font-xs grey--text"
              v-if="item.payment_type == 'transfer'"
            >
              โอนเงิน
              <!-- <i
                v-if="item.payment.payment_image_url != null"
                @click="viewSlip(item.payment.payment_image_url)"
                class="far fa-file-image"
              ></i> -->
            </span>
            <span class="font-xs grey--text" v-if="item.payment_type == 'cash'"
              >ชำระเงินสด</span
            >
            <span
              class="font-xs grey--text"
              v-if="item.payment_type == 'creditcard'"
              >บัตรเครดิต</span
            >
          </div>
        </template>
      </v-data-table>

      <div
        style="
          position: fixed;
          bottom: 10px;
          right: 10px;
          z-index: 9;
          width: 100%;
        "
      >
        <v-pagination
          circle
          v-model="page"
          :total-visible="5"
          :length="pageCount"
        ></v-pagination>
      </div>
    </el-card>

    <payment-dialog
      :showDialog="paymentInfoDialog"
      :order="selectedOrder"
      @close="paymentInfoDialog = false"
    ></payment-dialog>
  </v-container>
</template>

<script>
import Service from "@/services";
import moment from "moment";
import { mapState } from "vuex";

import PaymentDialog from "@/components/PaymentDialog";
export default {
  components: {
    PaymentDialog,
  },
  data() {
    return {
      mode: "admin",
      isLoading: true,
      date: "",
      orderList: [],
      page: 1,
      itemsPerPage: 25,
      pageCount: 0,
      refresh: null,
      amount: {
        revenue: 0,
        delivery: 0,
        food: 0,
        vat: 0,
        extra: 0,
        cog: 0,
        quantity: 0,
        completed: 0,
      },
      tableHeight: "0px",
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "order_type",
        },
        { text: "", value: "action", sortable: false },
        { text: "เวลา", value: "datetime_received", sortable: false },
        { text: "ข้อมูลลูกค้า", value: "user_ref_json", sortable: false },
        { text: "เส้นทาง", value: "delivery_info_json", sortable: false },
        { text: "จำนวนเงิน", value: "amount", sortable: false },
      ],
      statusOrdering: [
        "pending",
        "new",
        "acccepted",
        "delivering",
        "ready-to-go",
        "cooking",
        "processing",
        "completed",
        "cancelled",
      ],
      permission: null,
      paymentSlip: null,
      windowSize: null,
      paymentInfoDialog: false,
      selectedOrder: null,
    };
  },
  mounted() {
    this.onResize();
  },
  created() {
    Service.User.permission().then((resp) => {
      this.permission = resp.data;
      this.mode = this.permission.user.role_id;
    });
    this.date = moment().format("LLLL");

    this.loadOrder();
    // this.refresh = setInterval(() => {
    //   this.loadOrder();
    // }, 30000);
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
      //console.log(this.windowSize);
      this.tableHeight = window.innerHeight + "px";
    },
    loadOrder() {
      this.isLoading = true;
      this.amount = {
        revenue: 0,
        delivery: 0,
        food: 0,
        vat: 0,
        extra: 0,
        cog: 0,
        quantity: 0,
        discount: 0,
        completed: 0,
      };

      let begin = moment().format("YYYY-MM-DD");
      let end = moment().format("YYYY-MM-DD");
      Service.Order.gets(
        "order_type=delivery,delivery-self,pickup&per_page=15&begin=" +
          begin +
          "&end=" +
          end
      ).then((res) => {
        this.isLoading = false;
        if (res.success) {
          this.orderList = res.data.rows;

          this.orderList.sort(
            (a, b) =>
              this.statusOrdering.indexOf(a.status) -
              this.statusOrdering.indexOf(b.status)
          );

          /* stat */
          this.orderList.map((item) => {
            if (!["cancelled", "deleted"].includes(item.status)) {
              this.amount.revenue += parseFloat(item.amount.total);
              this.amount.delivery += parseFloat(item.amount.delivery);
              this.amount.food += parseFloat(item.amount.food);
              this.amount.vat += parseFloat(item.amount.vat);
              this.amount.extra += parseFloat(item.amount.extra);
              if (item.amount.discount != null) {
                this.amount.discount += parseFloat(item.amount.discount);
              }
              this.amount.completed++;

              let cog = 0;
              item.order_basket.product_list.map((product) => {
                cog += parseInt(product.cog) * product.quantity;
                this.amount.quantity += product.quantity;
              });
              item.amount.cog = cog;
              this.amount.cog += item.amount.cog;
            }
          });
        }
      });
    },
    openItem(item) {
      this.$router.push("/orders/" + item.order_reference + "/view");
    },
    viewSlip(url) {
      this.paymentSlip = url;
    },
    openPaymentInfo(item) {
      this.selectedOrder = item;
      this.paymentInfoDialog = true;
    },
  },
  beforeRouteLeave(to, from, next) {
    //this.$store.dispatch("Auth/setWorkState", "working");
    clearInterval(this.refresh);
    next();
  },
};
</script>
<style>
tbody tr:nth-of-type(even) {
  background-color: rgb(241, 241, 241);
}

tbody tr:nth-of-type(odd) {
  background-color: rgb(250, 250, 250);
}

.v-data-table-header {
  background-color: rgba(182, 183, 187);
  color: white;
}

.v-data-footer {
  background-color: rgb(250, 250, 250);
}

.theme--light.v-data-table thead tr th {
  color: white;
}
</style>
